import { render, staticRenderFns } from "./CompareChartStack.vue?vue&type=template&id=3bf3dfc2"
import script from "./CompareChartStack.vue?vue&type=script&lang=js"
export * from "./CompareChartStack.vue?vue&type=script&lang=js"
import style0 from "./CompareChartStack.vue?vue&type=style&index=0&id=3bf3dfc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports